import { StageRefreshFehler } from '../hooks/useStageRefresh';

export function erholbarerOeffnungsfehler(error: unknown): boolean {
  if (!(error instanceof StageRefreshFehler)) return false;
  if (error.art === 'zeitgrenze' || error.art === 'verbindung') return true;
  return error.art === 'http' && 'status' in error && [502, 503, 504].includes(Number(error.status));
}

/** At most one repeated read. Never extends the individual request deadline,
 * retries writes, or applies a result after the user has chosen another view. */
export async function leseOeffnungMitErholung<T>(
  lesen: () => Promise<T>, aktuell: () => boolean, wiederholung: () => void,
): Promise<T | null> {
  for (let versuch = 0; versuch < 2; versuch++) {
    if (!aktuell()) return null;
    // fallback-ok: A superseded navigation is cancelled, never treated as a loaded stage; current failures still reject after one bounded read retry.
    try {
      const stand = await lesen();
      return aktuell() ? stand : null;
    } catch (error) {
      if (!aktuell()) return null;
      if (versuch > 0 || !erholbarerOeffnungsfehler(error)) throw error;
      wiederholung();
      await new Promise<void>(resolve => setTimeout(resolve, 1500));
    }
  }
  return null;
}
